import i18n from 'i18next';
import locales from './locales.json';

i18n.init({
  resources: locales,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
